import { useSelector } from "react-redux";
import {
  getBasicDataForServicesOfResources,
  selectState,
} from "../slices/dtService.slice";
import { useAppDispatch } from "hooks/hooks";
import { useCallback, useEffect, useState } from "react";
import { IService } from "../domain/IService";
import Loader from "components/Loader/Loader";
import DateSelector from "Dashboard/components/DateSelector";
import { FormatDateIso, FormatDateShort } from "utils/dateUtils";
import { FormatNumberOrNull, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { unitNameLabel } from "Dashboard/scenes/Resources/helpers/resourceUtil";
import InfoTooltip from "components/Popup/InfoTooltip";
import { resourceMaintenanceTypeDictionary } from "utils/translationDictionary";

export const ServicePreview = () => {
  const { services, loading } = useSelector(selectState);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);
  const dispatch = useAppDispatch();

  const selectDate = useCallback((data: { dateFrom: Date; dateTo: Date }) => {
    setDateFrom(data.dateFrom);
    setDateTo(data.dateTo);
  }, []);

  useEffect(() => {
    if (dateFrom && dateTo) {
      dispatch(
        getBasicDataForServicesOfResources({
          dateFrom: FormatDateIso(dateFrom),
          dateTo: FormatDateIso(dateTo),
        }));
    }
  }, [dispatch, dateFrom, dateTo]);

  return (
    <div className="daily-table-services loading-container">
      {loading && <Loader />}
      <div className="previewHeader bolded red">
        <span>SERVIS &nbsp; POPRAVKA</span>
        <div>
          <DateSelector showYear={false} selectDate={selectDate} />
        </div>
      </div>
      <div className="previewBody">
        {services.map((service: IService) => (
          <div className="singleService">
            <InfoTooltip
              tooltip={service.resourceName}
              classesProp="daily-table-resource-service-name text-overflow"
              element="span"
            >
              {service.resourceName}
            </InfoTooltip>
            <InfoTooltip
              tooltip={`${resourceMaintenanceTypeDictionary[service.serviceType]} - ${service.consumableName}`}
              classesProp="daily-table-resource-service-item text-overflow"
              element="span"
            >
              {resourceMaintenanceTypeDictionary[service.serviceType]} - {service.consumableName}
            </InfoTooltip>
            <span className="daily-table-resource-service-quantity-container">
              <span className="daily-table-resource-service-quantity-amount">{FormatNumberOrNull(service.amount)}</span>
              <span className="daily-table-resource-service-quantity-equals">=</span>
            </span>
            <span className="daily-table-resource-service-price">
              {FormatNumberWithUnitOrNull(service.price, 'rsd')}
            </span>
            <span className="daily-table-resource-service-usage-container">
              <span className="daily-table-resource-service-usage-amount">{FormatNumberOrNull(service.serviceDoneAtUsageAmount)}</span>
              <span className="daily-table-resource-service-usage-unit">{unitNameLabel(service.resourceUsageUnit)}</span>
            </span>
            <span className="daily-table-resource-service-date">{FormatDateShort(service.serviceDoneAtDate)}</span>
            <span className="daily-table-resource-service-note">{service.note}</span>
          </div>
        ))}
        {services.length < 4 && <div className="singleService"></div>}
        {services.length < 3 && <div className="singleService"></div>}
        {services.length < 2 && <div className="singleService"></div>}
        {services.length < 1 && <div className="singleService"></div>}
      </div>
    </div>
  );
};
